import readAsBase64EncodedString from './read_as_base64_string'
import { fetchTextResponse, fetchBinaryResponse } from './ajax_helpers'

export function downloadPlaceholder (slideServerUrl) {
  return fetchTextResponse(slideServerUrl)
    .then(fetchBinaryResponse)
    .then(readAsBase64EncodedString)
  // Failed getting the placeholder bytes. We still need the promise resolved
  // instead of rejected, so we can properly wait for all such downloads
  // Resolve with an empty string, which signals native to use
  // the default placeholder
    .catch(err => {
      console.error(err)
      return ''
    })
}

/**
 * Safari in the current Mac App does not support resource preloading so
 * we're use continuing to use the ajax downloader for now
 *
 * @param {string} slideServerUrl Slide server URL of image
 */
export async function preloadPlaceholder (slideServerUrl) {
  try {
    const url = await fetchTextResponse(slideServerUrl)
    await fetchBinaryResponse(url)
  } catch {
    console.log(`Failed to preload ${slideServerUrl}`)
  }
}

export function placeholderUrl (slideServerUrl) {
  return fetchTextResponse(slideServerUrl)
    // Failed getting the placeholder URL. We still need the promise resolved
    // instead of rejected, so we can properly wait for all such attempts.
    // Resolve with an empty string, which signals native to use
    // the default placeholder
    .catch(() => '')
}
